import { orchestrator } from 'satcheljs';
import { logRibbonResponse } from '../actions/logRibbonResponse';
import { CaptureFeedbackDatapoint } from 'owa-feedback-common';

export default orchestrator(logRibbonResponse, async clickResponse => {
    const keys: string[] = ['frsid', 'frf', 'frsf', 'frrr', 'frmd'];

    let values: string[] = [
        clickResponse.SessionId,
        clickResponse.Feature,
        clickResponse.SubFeature,
        clickResponse.RibbonResponse,
        clickResponse.Metadata,
    ];

    await CaptureFeedbackDatapoint.import().then(captureFeedbackDatapoint => {
        captureFeedbackDatapoint({
            keys: keys,
            values: values,
        });
    });
});
